import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MediaObj } from 'src/app/models/models';

@Component({
  selector: 'blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css']
})
export class BlogsComponent implements OnInit {
  blogs: MediaObj[] = [];
  search: String = "";
  filteredBlogs: MediaObj[] = [];
  noBlogs: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.filteredBlogs = this.blogs;

    this.route.params.subscribe(routeParams => {
      let id: string = routeParams.id;

      if(id && id.length > 0)
        console.log(id);
    })
  }

  filterBlogs(){
    if(this.search.length==0)
      this.filteredBlogs = this.blogs;
    else{
      this.filteredBlogs = [];
      this.blogs.forEach(v=> {
        let s1 = v.title.toLowerCase() + ' ' + v.description.toLowerCase() +
        ' ' + v.date.toISOString();
        let s2 = this.search.toLowerCase();
        if(s1.includes(s2)){
          this.filteredBlogs.push(v);
        }
      });
    }

  }

  navigateTo(url: string){
    this.router.navigateByUrl(url)
  }

}
